module.exports = __webpack_public_path__ + "static/assets/0c3b85e58b16416b24df66d617f148b7.svg";